import { createAction } from 'redux-api-middleware';
import deep from 'deep-get-set';
import { createSelector } from 'reselect';
import qs from 'qs-lite';

import config from '../../config';
import { calculatePageCount } from './utils';
import { buildHeaders } from '../buildAuthHeader';
import { getFullMediaUrlFromPresignedUrl } from '../../utils/getFullMediaUrlFromPresignedUrl';

// Actions
export const MEDIA_DETAIL_LOAD = 'MEDIA_DETAIL_LOAD';
export const MEDIA_DETAIL_LOAD_FAILURE = 'MEDIA_DETAIL_LOAD_FAILURE';
export const MEDIA_DETAIL_LOAD_SUCCESS = 'MEDIA_DETAIL_LOAD_SUCCESS';
export const MEDIA_UPDATE_LOAD = 'MEDIA_UPDATE_LOAD';
export const MEDIA_UPDATE_FAILURE = 'MEDIA_UPDATE_FAILURE';
export const MEDIA_UPDATE_SUCCESS = 'MEDIA_UPDATE_SUCCESS';
export const MEDIA_SUBMISSIONS_LOAD = 'MEDIA_SUBMISSIONS_LOAD';
export const MEDIA_SUBMISSIONS_LOAD_FAILURE = 'MEDIA_SUBMISSIONS_LOAD_FAILURE';
export const MEDIA_SUBMISSIONS_LOAD_SUCCESS = 'MEDIA_SUBMISSIONS_LOAD_SUCCESS';
export const MEDIA_LIST_PAGE_SELECT = 'MEDIA_LIST_PAGE_SELECT';
export const MEDIA_LIST_PAGE_LOAD = 'MEDIA_LIST_PAGE_LOAD';
export const MEDIA_RECORDS_PER_PAGE_SET = 'MEDIA_RECORDS_PER_PAGE_SET';
export const MEDIA_LIST_COLUMN_SORT = 'MEDIA_LIST_COLUMN_SORT';
export const MEDIA_DELETE_LOAD = 'MEDIA_DELETE_LOAD';
export const MEDIA_DELETE_LOAD_SUCCESS = 'MEDIA_DELETE_LOAD_SUCCESS';
export const MEDIA_DELETE_LOAD_FAILURE = 'MEDIA_DELETE_LOAD_FAILURE';
export const MEDIA_DELETE_MODAL_SHOW = 'MEDIA_DELETE_MODAL_SHOW';
export const MEDIA_DELETE_MODAL_HIDE = 'MEDIA_DELETE_MODAL_HIDE';
export const MEDIA_PLAYER_MODAL_SHOW = 'MEDIA_PLAYER_MODAL_SHOW';
export const MEDIA_PLAYER_MODAL_HIDE = 'MEDIA_PLAYER_MODAL_HIDE';
export const MEDIA_THUMBNAIL_MODAL_HIDE = 'MEDIA_THUMBNAIL_MODAL_HIDE';
export const MEDIA_THUMBNAIL_MODAL_SHOW = 'MEDIA_THUMBNAIL_MODAL_SHOW';
export const FILTER_CAMPAIGNS_UPDATE = 'FILTER_CAMPAIGNS_UPDATE';
export const FILTER_TAGS_UPDATE = 'FILTER_TAGS_UPDATE';
export const FILTER_CRITERIA_CLEAR = 'FILTER_CRITERIA_CLEAR';

// THUMBNAIL BS
export const MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_LOAD = 'MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_LOAD';
export const MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_FAILURE = 'MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_FAILURE';
export const MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_SUCCESS = 'MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_SUCCESS';
export const MEDIA_THUMBNAIL_BUCKET_UPLOAD_LOAD = 'MEDIA_THUMBNAIL_BUCKET_UPLOAD_LOAD';
export const MEDIA_THUMBNAIL_BUCKET_UPLOAD_SUCCESS = 'MEDIA_THUMBNAIL_BUCKET_UPLOAD_SUCCESS';
export const MEDIA_THUMBNAIL_BUCKET_UPLOAD_FAIL = 'MEDIA_THUMBNAIL_BUCKET_UPLOAD_FAIL';

export const MEDIA_THUMBNAIL_IMAGE_ELEMENT_FILE_SELECT = 'MEDIA_THUMBNAIL_IMAGE_ELEMENT_FILE_SELECT';
export const MEDIA_THUMBNAIL_IMAGE_ELEMENT_LOAD_IMAGE = 'MEDIA_THUMBNAIL_IMAGE_ELEMENT_LOAD_IMAGE';
export const MEDIA_THUMBNAIL_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE = 'MEDIA_THUMBNAIL_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE';
export const MEDIA_THUMBNAIL_IMAGE_ELEMENT_SAVE_EDITED_IMAGE = 'MEDIA_THUMBNAIL_IMAGE_ELEMENT_SAVE_EDITED_IMAGE';
export const MEDIA_THUMBNAIL_IMAGE_ELEMENT_RESET = 'MEDIA_THUMBNAIL_IMAGE_ELEMENT_RESET';
export const RESET_CAMPAIGN_UPDATE_ERROR = 'RESET_CAMPAIGN_UPDATE_ERROR';

// Action Creators

// *** START THUMBNAIL ACTIONS ***
export const createMediaThumbnailPresignedUrl = (elementIndex) => createAction({
  endpoint: `${config.apiHost}${config.endpoints.preSignCampaignElementImageForS3}`,
  credentials: 'include',
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
  types: [
    MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_LOAD,
    {
      type: MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_SUCCESS,
      meta: { elementIndex }
    },
    {
      type: MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_FAILURE,
      meta: { elementIndex }
    },
  ],
});

export const uploadMediaThumbnailToBucket = (file, preSignedUrl, elementIndex) => createAction({
  endpoint: preSignedUrl,
  method: 'PUT',
  headers: {
    'Content-Type': file.type,
    'x-amz-acl': 'public-read'
  },
  body: file,
  types: [
    MEDIA_THUMBNAIL_BUCKET_UPLOAD_LOAD,
    {
      type: MEDIA_THUMBNAIL_BUCKET_UPLOAD_SUCCESS,
      meta: { elementIndex }
    },
    {
      type: MEDIA_THUMBNAIL_BUCKET_UPLOAD_FAIL,
      meta: { elementIndex }
    },
  ],
});

export function selectMediaThumbnailImageElementImage(elementIndex, loadedImage) {
  return {
    type: MEDIA_THUMBNAIL_IMAGE_ELEMENT_FILE_SELECT,
    elementIndex,
    loadedImage
  }
}

export function loadMediaThumbnailImageElementImage(elementIndex, url) {
  return {
    type: MEDIA_THUMBNAIL_IMAGE_ELEMENT_LOAD_IMAGE,
    elementIndex,
    url
  }
}

export function editMediaThumbnailImageElementImage(elementIndex, editMode) {
  return {
    type: MEDIA_THUMBNAIL_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE,
    elementIndex,
    editMode,
  }
}

export function saveMediaThumbnailEditedImage(elementIndex, editedImage) {
  return {
    type: MEDIA_THUMBNAIL_IMAGE_ELEMENT_SAVE_EDITED_IMAGE,
    elementIndex,
    editedImage,
  }
}

export function resetMediaThumbnailImageEditorState(elementIndex) {
  return {
    type: MEDIA_THUMBNAIL_IMAGE_ELEMENT_RESET,
    elementIndex
  }
}

export const showMediaThumbnailModal = () => ({
  type: MEDIA_THUMBNAIL_MODAL_SHOW,
});
export const hideMediaThumbnailModal = () => ({
  type: MEDIA_THUMBNAIL_MODAL_HIDE,
});
// *** END THUMBNAIL ACTIONS ***

export function selectMediaListPage(page) {
  return {
    type: MEDIA_LIST_PAGE_SELECT,
    page,
  };
}

export function setPageParams(queryParams) {
  return {
    type: MEDIA_LIST_PAGE_LOAD,
    queryParams,
  };
}

export function setRecordsPerPage(limit) {
  return {
    type: MEDIA_RECORDS_PER_PAGE_SET,
    limit,
  };
}

export function sortColumn(orderBy, sortOrder) {
  return {
    type: MEDIA_LIST_COLUMN_SORT,
    orderBy,
    sortOrder,
  };
}

export const fetchMediaList = (queryString = '') => createAction({
  endpoint: `${config.apiHost}${config.endpoints.media}${queryString}`,
  method: 'GET',
  headers: buildHeaders(),
  credentials: 'include',
  types: [
    MEDIA_SUBMISSIONS_LOAD,
    MEDIA_SUBMISSIONS_LOAD_SUCCESS,
    MEDIA_SUBMISSIONS_LOAD_FAILURE,
  ],
});

export const fetchMediaDetail = (mediaId) => createAction({
  endpoint: `${config.apiHost}${config.endpoints.media}/${mediaId}`,
  method: 'GET',
  headers: buildHeaders(),
  credentials: 'include',
  types: [
    MEDIA_DETAIL_LOAD,
    MEDIA_DETAIL_LOAD_SUCCESS,
    MEDIA_DETAIL_LOAD_FAILURE,
  ],
});

export const updateMediaById = (mediaId, body) => createAction({
  endpoint: `${config.apiHost}${config.endpoints.media}/${mediaId}`,
  method: 'PUT',
  headers: buildHeaders(),
  credentials: 'include',
  body: JSON.stringify(body),
  types: [
    MEDIA_UPDATE_LOAD,
    MEDIA_UPDATE_SUCCESS,
    MEDIA_UPDATE_FAILURE,
  ],
});

export const deleteMedia = (mediaId) => createAction({
  endpoint: `${config.apiHost}${config.endpoints.media}/${mediaId}`,
  method: 'DELETE',
  headers: buildHeaders(),
  credentials: 'include',
  types: [
    MEDIA_DELETE_LOAD,
    MEDIA_DELETE_LOAD_SUCCESS,
    MEDIA_DELETE_LOAD_FAILURE,
  ],
});

export const showMediaDeleteModal = (mediaId) => {
  return {
    type: MEDIA_DELETE_MODAL_SHOW,
    mediaId,
  };
}

export const hideMediaDeleteModal = () => {
  return {
    type: MEDIA_DELETE_MODAL_HIDE,
  };
}

export function showMediaPlayerModal(mediaUrl) {
  return {
    type: MEDIA_PLAYER_MODAL_SHOW,
    mediaUrl,
  };
}

export function hideMediaPlayerModal() {
  return {
    type: MEDIA_PLAYER_MODAL_HIDE,
  };
}

export function clearFilterCriteria() {
  return {
    type: FILTER_CRITERIA_CLEAR,
  };
}

export function updateTagsFilter(tags) {
  return {
    type: FILTER_TAGS_UPDATE,
    tags,
  };
}

export function updateCampaignFilter(campaigns) {
  return {
    type: FILTER_CAMPAIGNS_UPDATE,
    campaigns,
  };
}

export const resetMediaUpdateError = () => ({
  type: RESET_CAMPAIGN_UPDATE_ERROR,
});

// Initial State
const initialState = {
  isLoading: false,
  isLoaded: false,
  isFailed: false,
  errorMessage: '',
  queryParams: {},
  shouldShowMediaDeleteModal: false,
  mediaIdToDelete: null,
  shouldShowMediaPlayerModal: false,
  shouldShowMediaThumbnailModal: false,
  currentMediaUrl: null,
  meta: {},
  data: [],
  thumbnailImageData: {}
};

// Reducer Helpers
function normalizeSelectedFilterOptions(selectedOptions) {
  // Handle arrays with falsy values [null] || [NaN] etc
  if (Array.isArray(selectedOptions) && !!selectedOptions[0] === false) {
    return undefined;
  }

  return selectedOptions;
}

// Reducers
export function mediaReducer(state = initialState, action) {
  switch(action.type) {
    case '@@router/LOCATION_CHANGE': {
      const shouldDeleteQueryParams = action.payload
        && action.payload.pathname
        && action.payload.pathname !== '/media';

      const newState = {
        ...state,
        queryParams: {}
      };

      return shouldDeleteQueryParams ? newState : state;
    }

    case MEDIA_LIST_PAGE_LOAD: {
      const newState = {
        ...state,
        isLoading: true,
        queryParams: {
          ...state.queryParams,
          // Only query params that are explicitly set here
          // will be able to be persisted to the back end API
          // We throw away everything else in the browser URL
          page: parseInt(action.queryParams.page, 10) || 1,
          limit: action.queryParams.limit || config.mediaRecordsPerPageDefault,
          orderBy: action.queryParams.orderBy || 'uploadDate',
          sortOrder: action.queryParams.sortOrder || 'DESC',
          term: action.queryParams.term,
          from: action.queryParams.from,
          campaignIds: normalizeSelectedFilterOptions(action.queryParams?.campaignIds?.split(',').map(c => parseInt(c, 10))),
          tagIds: normalizeSelectedFilterOptions(action.queryParams?.tagIds?.split(',')),
        }
      };

      return newState;
    }

    case MEDIA_UPDATE_LOAD: {
      const newState = {
        ...state,
        mediaUpdateLoading: true,
        mediaUpdateError: null,
        mediaUpdateSuccess: false,
      };

      return newState;
    }

    case MEDIA_DETAIL_LOAD: {
      const newState = {
        ...state,
        isLoading: true,
        isLoaded: false,
        isFailed: false,
        errorMessage: '',
        // Clear out query params so browser back button works
        queryParams: {}
      };

      return newState;
    }

    case MEDIA_SUBMISSIONS_LOAD: {
      const newState = {
        ...state,
        isLoading: true,
        isLoaded: false,
        isFailed: false,
        errorMessage: '',
        queryParams: {
          ...state.queryParams,
          from: undefined,
        }
      };

      return newState;
    }

    case MEDIA_UPDATE_FAILURE: {
      const newState = {
        ...state,
        mediaUpdateLoading: false,
        mediaUpdateError: action.payload.response || { error: 'Unknown Error '},
      }

      return newState;
    }

    case MEDIA_DETAIL_LOAD_FAILURE:
    case MEDIA_SUBMISSIONS_LOAD_FAILURE: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: false,
        isFailed: true,
        errorMessage: action.payload.response.message,
      };

      return newState;
    }

    case MEDIA_SUBMISSIONS_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: true,
        isFailed: false,
        errorMessage: '',
        meta: {
          ...action.payload.meta,
          pageCount: calculatePageCount(action.payload.meta.count, action.payload.meta.limit),
        },
        data: action.payload.data,
      };

      return newState;
    }

    case MEDIA_UPDATE_SUCCESS: {
      const newState = {
        ...state,
        mediaUpdateLoading: false,
        mediaUpdateSuccess: true,
        meta: action.payload.meta,
        data: action.payload.data,
      };

      return newState;
    }

    case MEDIA_DETAIL_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: true,
        isFailed: false,
        errorMessage: '',
        meta: action.payload.meta,
        data: action.payload.data,
      };

      return newState;
    }

    case MEDIA_LIST_PAGE_SELECT: {
      const newState = {
        ...state,
        queryParams: {
          ...state.queryParams,
          page: action.page,
        }
      };

      return newState;
    }

    case MEDIA_RECORDS_PER_PAGE_SET: {
      // when changing the # of records per page, we will change the current
      // selected page to one that contains the previous top result displayed on the page
      const prevTopResult = state.meta.offset + 1;
      const newLimit = action.limit;
      const newPageCount = calculatePageCount(state.meta.count, newLimit);

      const pageContainingPrevTopResult = Math.ceil(prevTopResult / newLimit);

      const newState = {
        ...state,
        meta: {
          pageCount: newPageCount,
        },
        queryParams: {
          ...state.queryParams,
          limit: newLimit,
          page: pageContainingPrevTopResult,
        },
      };

      return newState;
    }

    case MEDIA_LIST_COLUMN_SORT: {
      const newState = {
        ...state,
        queryParams: {
          ...state.queryParams,
          orderBy: action.orderBy,
          sortOrder: action.sortOrder,
        }
      };

      return newState;
    }

    case MEDIA_DELETE_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowMediaDeleteModal: true,
        mediaIdToDelete: action.mediaId,
      };

      return newState;
    }

    case MEDIA_DELETE_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowMediaDeleteModal: false,
        mediaIdToDelete: null,
      };

      return newState;
    }

    case MEDIA_PLAYER_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowMediaPlayerModal: true,
        currentMediaUrl: action.mediaUrl,
      };

      return newState;
    }

    case MEDIA_PLAYER_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowMediaPlayerModal: false,
        currentMediaUrl: null,
      };

      return newState;
    }

    case FILTER_CRITERIA_CLEAR: {
      const newState = {
        ...state,
        queryParams: {
          ...state.queryParams,
          campaignIds: undefined,
          tagIds: undefined,
          page: 1 // reset to page one when clearing filters
        }
      };

      return newState;
    }

    case FILTER_TAGS_UPDATE: {
      const newState = {
        ...state,
        queryParams: {
          ...state.queryParams,
          tagIds: normalizeSelectedFilterOptions(action.tags),
          page: 1 // reset to page one when updating tags filter
        }
      };

      return newState;
    }

    case FILTER_CAMPAIGNS_UPDATE: {
      const newState = {
        ...state,
        queryParams: {
          ...state.queryParams,
          campaignIds: normalizeSelectedFilterOptions(action.campaigns),
          page: 1 // reset to page one when updating campaign filter
        },
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowMediaThumbnailModal: true,
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowMediaThumbnailModal: false,
        thumbnailImageData: {
          ...state?.thumbnailImageData,
          successfullyUploadedMediaUrl: false,
        },
      };

      return newState;
    }

    // *** THUMBNAIL BS
    case MEDIA_THUMBNAIL_IMAGE_ELEMENT_FILE_SELECT: {
      const newState = {
        ...state,
        thumbnailImageData: {
          ...state.thumbnailImageData,
          loadedImage: action?.loadedImage,
          editMode: true,
        }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_IMAGE_ELEMENT_LOAD_IMAGE: {
      const newState = {
        ...state,
          thumbnailImageData: {
            ...state.thumbnailImageData,
            mediaUrl: action.url,
        }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            editMode: action.editMode,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_IMAGE_ELEMENT_SAVE_EDITED_IMAGE: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            loadedImage: action.editedImage,
            editMode: false,
        }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_IMAGE_ELEMENT_RESET: {
      const newState = {
        ...state,
        mediaUpdateSuccess: false,
        thumbnailImageData: {
          ...state.thumbnailImageData,
          isDirty: false,
          loadedImage: null,
          editMode: false,
          hasUploadError: false,
          presignedUrl: null,
          mediaUrl: null,
        },
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_LOAD: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            isDirty: true,
            isPresignedUrlLoading: true,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            isDirty: true,
            presignedUrl: action?.payload?.presignedUrl,
            isPresignedUrlLoading: false,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_PRE_SIGNED_URL_REQUEST_FAILURE: {
      const newState = {
        ...state,
          thumbnailImageData: {
            ...state.thumbnailImageData,
            // isDirty: false,
            hasUploadError: true,
            isLoading: false,
            presignedUrl: null,
            isPresignedUrlLoading: false,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_BUCKET_UPLOAD_LOAD: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            isBucketUploadLoading: true,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            isDirty: false,
            presignedUrl: null,
            loadedImage: null,
            isLoading: false,
            mediaUrl: getFullMediaUrlFromPresignedUrl(state?.thumbnailImageData?.presignedUrl),
            successfullyUploadedMediaUrl: true,
            isBucketUploadLoading: false,
          }
      };

      return newState;
    }

    case MEDIA_THUMBNAIL_BUCKET_UPLOAD_FAIL: {
      const newState = {
        ...state,
        thumbnailImageData: {
            ...state.thumbnailImageData,
            isDirty: false,
            hasUploadError: true,
            isLoading: false,
            presignedUrl: null,
            isBucketUploadLoading: false,
          }
      };

      return newState;
    }

    case RESET_CAMPAIGN_UPDATE_ERROR: {
      return {
        ...state,
        mediaUpdateError: false,
      };
    }

    default: {
      return state;
    }
  }
}

// Selectors
export const getMedia = createSelector(
  state => state,
  state => state.get('media'),
);

export const getMediaData = createSelector(
  getMedia,
  media => deep(media, 'data'),
);

export const getMediaIds = createSelector(
  getMediaData,
  data => data.map(m => m.mediaId),
);

export const getEnabledMediaIds = createSelector(
  getMediaData,
  data => data.filter(m => m.enabled).map(m => m.mediaId),
);

export const getSubmissionByMediaId = createSelector(
  (state, mediaId) => getMediaData(state, mediaId),
  (state, mediaId) => (state, mediaId),
  (mediaData, mediaId) => {
    // if data is not an array, return it. It's already an object
    if (!Array.isArray(mediaData)) {
      return mediaData;
    }

    return mediaData.find(submission => submission.mediaId === mediaId);
  }
);

export const getMediaMeta = createSelector(
  getMedia,
  media => deep(media, 'meta'),
);

export const getIsMediaListLoading = createSelector(
  getMedia,
  media => deep(media, 'isLoading'),
);

export const getMediaQueryParams = createSelector(
  getMedia,
  media => deep(media, 'queryParams'),
);

export const getCurrentPage = createSelector(
  getMediaQueryParams,
  queryParams => deep(queryParams, 'page') || 1,
);

export const getListApiQueryParams = createSelector(
  getMediaQueryParams,
  queryParams => {
    if (Object.keys(queryParams).length > 0) {
      const queryParamsCopy = {
        ...queryParams,
        offset: (parseInt(queryParams.page - 1, 10)) * parseInt(queryParams.limit, 10),
        page: undefined, // remove from object so it does not get serialized
      };

      return `?${qs.stringify(queryParamsCopy, { skipNulls: true })}`;
    }

    return '';
  }
);

export const getListBrowserQueryParams = createSelector(
  getMediaQueryParams,
  queryParams => queryParams,
);

export const getPageCount = createSelector(
  getMediaMeta,
  meta => deep(meta, 'pageCount'),
);

export const getResultCount = createSelector(
  getMediaMeta,
  meta => deep(meta, 'count'),
);

export const getVideosCollectedThisMonth = createSelector(
  getMediaMeta,
  meta => meta?.videosCollectedThisMonth,
);

export const getIsVideoCollectionExpired = createSelector(
  getMediaMeta,
  meta => meta?.isVideoCollectionExpired,
);

export const getRecordsPerPage = createSelector(
  getMediaMeta,
  meta => deep(meta, 'limit'),
);

export const getSortedColumn = createSelector(
  getMediaQueryParams,
  queryParams => deep(queryParams, 'orderBy'),
);

export const getSortOrder = createSelector(
  getMediaQueryParams,
  queryParams => deep(queryParams, 'sortOrder'),
);

export const getHasNoMedia = createSelector(
  getMediaData,
  data => data.length === 0 || data.length === undefined,
);

export const getCampaignResponses = createSelector(
  getMediaData,
  data => deep(data, 'responses') || [],
);

export const getThumbnailUrl = createSelector(
  getMediaData,
  data => deep(data, 'thumbnailUrl'),
);

export const getMediaTitle = createSelector(
  getMediaData,
  data => data?.title,
);

export const getMediaDescription = createSelector(
  getMediaData,
  data => data?.description,
);

export const getMediaTranscriptionContent = createSelector(
  getMediaData,
  data => data?.transcriptionContent,
);

export const getMediaTranscriptionStatus = createSelector(
  getMediaData,
  data => (data?.transcriptionStatus),
);

export const getMediaUrl = createSelector(
  getMediaData,
  data => deep(data, 'mediaUrl'),
);

export const getShouldShowMediaDeleteModal = createSelector(
  getMedia,
  media => deep(media, 'shouldShowMediaDeleteModal'),
);

export const getShouldShowMediaThumbnailModal = createSelector(
  getMedia,
  media => media?.shouldShowMediaThumbnailModal,
);

export const getMediaId = createSelector(
  getMediaData,
  data => deep(data, 'mediaId') || '',
);

export const getMediaIdToDelete = createSelector(
  getMedia,
  data => deep(data, 'mediaIdToDelete'),
);

export const getShouldShowMediaPlayerModal = createSelector(
  getMedia,
  media => deep(media, 'shouldShowMediaPlayerModal'),
);

export const getCurrentMediaUrl = createSelector(
  getMedia,
  media => deep(media, 'currentMediaUrl') || '',
);

export const getHasLoadingFailure = createSelector(
  getMedia,
  media => deep(media, 'isFailed'),
);

export const getCampaignFilters = createSelector(
  getMediaQueryParams,
  queryParams => deep(queryParams, 'campaignIds') || [],
);

export const getTagFilters = createSelector(
  getMediaQueryParams,
  queryParams => deep(queryParams, 'tagIds') || [],
);

// THUMBNAIL BS
export const getMediaThumbnailImageData = createSelector(
  getMedia,
  data => data?.thumbnailImageData,
)
export const getMediaThumbnailSuccessfullyUploadedMediaUrl = createSelector(
  getMediaThumbnailImageData,
  data => data?.successfullyUploadedMediaUrl,
);
export const getMediaThumbnailElementHasUploadError = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.hasUploadError || false,
);

export const getMediaThumbnailElementPresignedUrl = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.presignedUrl || null,
);

export const getMediaThumbnailElementMediaUrl = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.mediaUrl || null,
);

export const getMediaThumbnailElementEditMode = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.editMode || false,
);

export const getMediaThumbnailElementLoadedImage = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.loadedImage || null,
);

export const getMediaThumbnailElementIsLoading = createSelector(
  getMediaThumbnailImageData,
  (thumbnail) => thumbnail?.isLoading || false,
);
export const getMediaThumbnailIsPresignedUrlLoading = createSelector(
  getMediaThumbnailImageData,
  data => data?.isPresignedUrlLoading,
);
export const getMediaThumbnailIsBucketUploadLoading = createSelector(
  getMediaThumbnailImageData,
  data => data?.isBucketUploadLoading,
);
export const getMediaUpdateLoading = createSelector(
  getMedia,
  (media) => media?.mediaUpdateLoading,
);
export const getMediaUpdateError = createSelector(
  getMedia,
  (media) => media?.mediaUpdateError,
);
export const getMediaUpdateSuccess = createSelector(
  getMedia,
  (media) => media?.mediaUpdateSuccess,
);




// WEBPACK FOOTER //
// ./src/redux/modules/media.js